import {
  GenericMaster,
  KMTPaginatorDataSource,
} from '../global-entities/global-entities';
import { TranslatedEntities } from '../global-entities/global-enums';
import { BaseLocalizationAdapter } from './base-localization-adapter';

export class TranslatedEntitiesMaster extends GenericMaster<TranslatedEntities> {
  adapter: BaseLocalizationAdapter;
  pagination: KMTPaginatorDataSource;
}
export class MLEntityLocale {
  EntityId: number;
  LangCode: string;
  Name?: string;
}

export class MLEntity {
  EntityId: number;
  Name?: string;
  Type?: number | string;
  Locale?: MLEntityLocale[];
}

export class MLEntityResponse {
  constructor(public ListMLEntities: MLEntity[]) {}
}
